import React from 'react';
import cx from 'classnames';
import styles from './EnvironmentsView.scss';
import TranslatableHelmet from '../../../components/TranslatableHelmet';
import { PageHeader } from 'sema-ui-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { browserHistory } from 'react-router';
import { Button, Heading } from 'suomifi-ui-components';
export const EnvironmentTypeSelector = props => {
  const handleOnclick = oidc => {
    browserHistory.push(
      `/${props.params.lang}/tunnistus/${encodeURIComponent(
        props.currentProvider.nameFI
      )}/rekisteroi-${oidc ? 'oidc-' : ''}ymparisto`
    );
  };
  return (
    <div>
      <TranslatableHelmet locale={props.params.lang} />
      <PageHeader
        title={
          <span>
            {
              <FormattedMessage
                id={'identification_admin.environment.service_prefix'}
              />
            }
            {props.currentProvider[`name${props.params.lang.toUpperCase()}`]}
          </span>
        }
        description={
          <span>
            {
              props.currentProvider[
                `description${props.params.lang.toUpperCase()}`
              ]
            }
          </span>
        }
        routes={props.routes}
        params={props.params}
      />
      <Heading variant={'h3'}>
        <FormattedMessage
          id={'identification_admin.environment.register_oidc.select_type'}
        />
      </Heading>
      <div>
        <Button my={'l'} onClick={() => handleOnclick(true)}>
          <FormattedMessage
            id={'identification_admin.environment.register_oidc.oidc'}
          />
        </Button>
      </div>
      <div>
        <Button onClick={() => handleOnclick(false)}>
          <FormattedMessage
            id={'identification_admin.environment.register_oidc.saml'}
          />
        </Button>
      </div>
    </div>
  );
};

export default injectIntl(EnvironmentTypeSelector);
